import { render } from "./Excess.vue?vue&type=template&id=a3a8a37e"
import script from "./Excess.vue?vue&type=script&lang=js"
export * from "./Excess.vue?vue&type=script&lang=js"

import "./Excess.vue?vue&type=style&index=0&id=a3a8a37e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__